
  (function () {
    function start() {
      var kar = document.querySelector('.carousel');
      if (!kar || kar.children.length === 0) return;

      var anzahl = kar.children.length;
      var SAETZE = 5;          // Originalsatz + 4 Klonsaetze
      var MITTE = 2;           // Arbeitsfenster liegt im dritten Satz
      for (var runde = 1; runde < SAETZE; runde++) {
        for (var i = 0; i < anzahl; i++) {
          var klon = kar.children[i].cloneNode(true);
          klon.setAttribute('aria-hidden', 'true');
          klon.setAttribute('tabindex', '-1');
          klon.removeAttribute('aria-label');
          kar.appendChild(klon);
        }
      }

      var TEMPO = 40;          // Pixel pro Sekunde - langsames, stetiges Gleiten
      var HOVER_MAX = 30000;   // Notbremse: nie laenger als 30 s stillstehen
      var haltBis = 0;
      var zeigerDrin = false;
      var zeigerSeit = 0;
      var pos = 0, zuletzt = 0, letzteZeit = 0;

      var reduziert = false;
      try { reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

      function satzBreite() {
        var k = kar.children[anzahl];
        return k ? k.offsetLeft - kar.children[0].offsetLeft : 0;
      }
      function imFenster(x, b) {                 // auf das Arbeitsfenster zurueckfalten
        var u = MITTE * b, o = (MITTE + 1) * b;
        while (x >= o) x -= b;
        while (x < u) x += b;
        return x;
      }

      function pausiereFuer(ms) {
        var z = Date.now() + ms;
        if (z > haltBis) haltBis = z;
      }
      function zeigerRaus() { zeigerDrin = false; }
      function ruht() {
        if (Date.now() < haltBis) return true;
        if (zeigerDrin && Date.now() - zeigerSeit < HOVER_MAX) return true;
        return false;
      }

      kar.addEventListener('mouseenter', function () { zeigerDrin = true; zeigerSeit = Date.now(); });
      kar.addEventListener('mouseleave', zeigerRaus);
      document.addEventListener('mousemove', function (e) {
        var drin = !!(e.target && kar.contains(e.target));
        if (drin) { if (!zeigerDrin) { zeigerDrin = true; zeigerSeit = Date.now(); } }
        else zeigerDrin = false;
      });
      document.addEventListener('mouseleave', zeigerRaus);
      window.addEventListener('blur', zeigerRaus);
      kar.addEventListener('pointerdown', function () { pausiereFuer(2500); });
      kar.addEventListener('touchstart', function () { pausiereFuer(2500); }, { passive: true });
      kar.addEventListener('wheel', function () { pausiereFuer(2000); }, { passive: true });
      kar.addEventListener('keydown', function () { pausiereFuer(2500); });

      // Auch beim Wischen von Hand endlos: sobald die Position das Fenster verlaesst,
      // wird sie unsichtbar um genau einen Satz zurueckgesetzt.
      kar.addEventListener('scroll', function () {
        var b = satzBreite();
        if (b <= 0) return;
        var x = kar.scrollLeft;
        var y = imFenster(x, b);
        if (Math.abs(y - x) > 0.5) {
          kar.scrollLeft = y;
          pos = kar.scrollLeft;
          zuletzt = pos;
        }
      });

      function rahmen(zeit) {
        requestAnimationFrame(rahmen);
        var dt = letzteZeit ? Math.min(zeit - letzteZeit, 100) : 0;
        letzteZeit = zeit;
        var b = satzBreite();
        if (b <= 0 || !kar.offsetParent || document.hidden) return;
        if (ruht() || reduziert) {                 // Nutzer steuert selbst
          pos = kar.scrollLeft; zuletzt = pos;
          return;
        }
        if (Math.abs(kar.scrollLeft - zuletzt) > 1.5) pos = kar.scrollLeft;
        pos = imFenster(pos + TEMPO * dt / 1000, b);
        kar.scrollLeft = pos;
        zuletzt = kar.scrollLeft;
      }

      function einrichten() {
        var b = satzBreite();
        if (b > 0) { kar.scrollLeft = MITTE * b; pos = kar.scrollLeft; zuletzt = pos; }
      }
      if (window.requestAnimationFrame) {
        requestAnimationFrame(function () { einrichten(); requestAnimationFrame(rahmen); });
      }
      window.addEventListener('resize', einrichten);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  
;

(function() {
  var sections = document.querySelectorAll('.page-section');
  var navLinks = document.querySelectorAll('.nav-link');
  if (!sections.length) return;   // andere Shopify-Seiten (Produkt, Warenkorb ...)
  function showPage(key) {
    if (key === 'donuts' && document.body.classList.contains('nd-urlaub')) key = 'home';
    document.querySelectorAll('.page-section').forEach(function(s) {
      s.style.display = (s.getAttribute('data-page') === key) ? 'block' : 'none';
    });
    navLinks.forEach(function(a) {
      var active = a.getAttribute('data-nav') === key;
      a.style.color = active ? '#8A2BE2' : '#685848';
      a.style.fontWeight = active ? '700' : '500';
      a.classList.toggle('is-active', active);
    });
    ['home','donuts','catering','story','kontakt','impressum','agb','widerrufsrecht'].forEach(function (k) { document.body.classList.toggle('page-' + k, key === k); });
    if (key === 'donuts' && window.NadosCart && window.NadosCart.close) window.NadosCart.close();
    window.scrollTo(0, 0);
  }
  function currentKey() {
    var h = (window.location.hash || '#home').replace('#', '');
    var valid = ['home','donuts','catering','story','kontakt','impressum','agb','widerrufsrecht'];
    return valid.indexOf(h) !== -1 ? h : 'home';
  }
  window.addEventListener('hashchange', function() { showPage(currentKey()); });
  showPage(currentKey());

  // Direkter, verlaesslicher Sprung zum Kontaktformular – unabhaengig davon,
  // ob der Browser das hashchange-Event in jedem Fall zuverlaessig ausloest.
  function springeZumKontaktformular(e) {
    if (e) e.preventDefault();
    // Catering-Anfrage: das Kontaktformular schickt sie an die CateringAPP statt als normale Nachricht (nados-3.js)
    var kontaktForm = document.getElementById('kontakt-form');
    if (kontaktForm) kontaktForm.setAttribute('data-catering', '1');
    var betreff = e && e.currentTarget ? e.currentTarget.getAttribute('data-betreff') : null;
    if (betreff) {
      var betreffFeld = document.getElementById('kf-betreff');
      if (window.NadosI18n && NadosI18n.get && NadosI18n.get() === 'en') betreff = NadosI18n.t(betreff);
      if (betreffFeld) betreffFeld.value = betreff;
    }
    showPage('kontakt');
    if (window.location.hash !== '#kontakt') window.location.hash = 'kontakt';
    // Das Setzen von location.hash loest ein zusaetzliches hashchange-Event
    // aus, das intern showPage() erneut aufruft – und das endet mit
    // window.scrollTo(0,0), was unseren Sprung zum Formular sofort wieder
    // rueckgaengig macht. Deshalb wird der eigentliche Sprung zum Formular
    // bewusst zeitverzoegert ausgefuehrt: garantiert NACH diesem Reset, egal
    // in welcher Reihenfolge Browser das hashchange-Event verarbeiten.
    var form = document.getElementById('kontakt-form');
    if (form) {
      setTimeout(function () {
        var rect = form.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        var ziel = rect.top + scrollTop - 90;
        window.scrollTo(0, Math.max(ziel, 0));
      }, 80);
    }
  }
  var ctaCateringButtons = document.querySelectorAll('#cta-catering-anfragen, .cta-catering-paket');
  ctaCateringButtons.forEach(function (btn) {
    btn.addEventListener('click', springeZumKontaktformular);
  });
})();

;
(function () {
  if (!(window.Shopify && Shopify.designMode)) return;
  document.addEventListener('shopify:section:select', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('.page-section') : null;
    var p = s ? s.getAttribute('data-page') : null;
    if (p && location.hash !== '#' + p) location.hash = p;
  });
  document.addEventListener('shopify:block:select', function (e) {   // App-Block gewaehlt: passende Seite zeigen
    var s = e.target && e.target.closest ? e.target.closest('.page-section') : null;
    var p = s ? s.getAttribute('data-page') : null;
    if (p && location.hash !== '#' + p) location.hash = p;
  });
  document.addEventListener('shopify:section:load', function () {
    try { window.dispatchEvent(new HashChangeEvent('hashchange')); } catch (e) { window.location.hash = window.location.hash; }
  });
})();
